module.exports = __webpack_public_path__ + "img/DSC_0341.NEF.fc4f85d3.jpg";